// extracted by mini-css-extract-plugin
export var aircallIframe = "_gp-3";
export var fabContainer = "_gp-5";
export var fabRinging = "_gp-6";
export var loadingOverlay = "_gp-4";
export var pulse = "_gp-7";
export var widgetContent = "_gp-2";
export var widgetPanel = "_gp-0";
export var widgetPanelExpanded = "_gp-1";